import { useEffect } from 'react';
import { X } from 'lucide-react';
import { R, ft, shadow } from '../lib/ui';

/**
 * Общая модалка: заголовок, крестик, Escape и клик по подложке.
 * Ширина задаётся вызывающим — в оригинале 420 по умолчанию,
 * 440 у свойств документа, 640 у условного форматирования.
 */
export function Modal({
  title, onClose, children, width = 420,
}: {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  width?: number;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(20,18,17,.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 100,
        animation: 'rtFade .12s ease',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width,
          maxWidth: '100%',
          maxHeight: 'calc(100vh - 32px)',
          display: 'flex',
          flexDirection: 'column',
          background: R.bgPanel,
          border: ft.strong,
          boxShadow: shadow.panel,
          animation: 'rtIn .18s ease',
        }}
      >
        <header
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '14px 18px',
            borderBottom: ft.strong,
            flex: '0 0 auto',
          }}
        >
          <h3 style={{ fontSize: 17, fontWeight: 800, color: R.text }}>{title}</h3>
          <button
            onClick={onClose}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 26,
              height: 26,
              color: R.textMuted,
              background: 'transparent',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = R.bgElevated)}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
          >
            <X size={16} />
          </button>
        </header>

        <div
          className="rt-scroll"
          style={{ padding: 18, overflowY: 'auto', flex: 1, minHeight: 0 }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
